export const BlockingCalloutComponent = {
    template: `
        <modal open="$ctrl.isVisible" close-callback="$ctrl.hide()">
            <modal-content ng-transclude>
                <p c-type="body-md-primary">{{$ctrl.message}}</p>
            </modal-content>
            <modal-footer>
                <button ng-click="$ctrl.cancel()" c-button="link" ng-if="$ctrl.cancelText">{{$ctrl.cancelText}}</button>
                <button ng-click="$ctrl.ok()" c-button="link">{{$ctrl.okText}}</button>
            </modal-footer>
        </modal>
    `,
    transclude: '?',
    bindings: {
        // A function that will always be called when the callout is closed, regardless of
        // what action caused it to close (including clicking the mask).
        closeCallback: '<',
        // A function that will be called when the user clicks the ok button. closeCallback
        // will be called afterward.
        okCallback: '<?',
        // A function that will be called when the user clicks the cancel button. closeCallback
        // will be called afterward.
        cancelCallback: '<?',
        // The ok action will always appear with a default display value unless passed in here.
        okText: '<?',
        // The cancel action will appear if a truthy display value is passed in. If === true,
        // a default display value will be used.
        cancelText: '<?',
        message: '<?'
    },
    controller: class {
        constructor(ModalService) {
            'ngInject';
            Object.assign(this, { ModalService });
            this.isVisible = true;
            this.ModalService.modalShown();
        }

        $postLink() {
            // Always show the ok action, but allow for a default value.
            this.okText = (true === this.okText || !this.okText) ? 'Got It' : this.okText;
            // Only show the cancel action if requested, and allow for a default value.
            this.cancelText = true === this.cancelText ? 'Cancel' : this.cancelText;

            this.cancelCallback = this.cancelCallback || angular.noop;
            this.okCallback = this.okCallback || angular.noop;
        }

        hide() {
            this.ModalService.modalHidden();
            this.closeCallback();
            this.isVisible = false;
        }

        cancel() {
            this.cancelCallback();
            this.hide();
        }

        ok() {
            this.okCallback();
            this.hide();
        }
    }
};
